/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/books.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import Upload from '../../component/Inc/Upload';
import Modal from '../../component/Inc/Modal';

const SendMail = () => {
  const navigate = useNavigate();
  const [modalAlert, setModalAlert] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '홍보학생 목록', value: 0},
    {title: '학생 목록', value: 1},
    {title: '교사 목록', value: 2},
    {title: '직원 목록', value: 3}
  ];
  return (
    <main className="com_container p_send_mail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_10">문자/메일 보내기</h2>
					<div className="com_btn_wrap">
					<button   onClick={() => {
                      navigate('/Promotion/SendMail/Rejection');
                    }} className="com_btn s orange ">수신 거부 목록</button></div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="이름 검색" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_input_wrap check_wrap">
              <div className="check">
                <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                <label htmlFor="chk01">전체</label>
                <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                <label htmlFor="chk02">국어</label>
                <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                <label htmlFor="chk03">영어</label>
                <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                <label htmlFor="chk04">수학</label>
                <input type="checkbox" name="chk" id="chk05" className="com_chk" />
                <label htmlFor="chk05">과탐</label>
                <input type="checkbox" name="chk" id="chk06" className="com_chk" />
                <label htmlFor="chk06">사탐</label>
                <input type="checkbox" name="chk" id="chk07" className="com_chk" />
                <label htmlFor="chk07">수시</label>
                <input type="checkbox" name="chk" id="chk08" className="com_chk" />
                <label htmlFor="chk08">논술</label>
              </div>
              <div className="check">
                <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
                <label htmlFor="chkAll">전체</label>
                <input type="checkbox" name="chk" id="chk09" className="com_chk" />
                <label htmlFor="chk09">인사팀</label>
                <input type="checkbox" name="chk" id="chk10" className="com_chk" />
                <label htmlFor="chk10">회계팀</label>
                <input type="checkbox" name="chk" id="chk11" className="com_chk" />
                <label htmlFor="chk11">마케팅팀</label>
                <input type="checkbox" name="chk" id="chk12" className="com_chk" />
                <label htmlFor="chk12">디자인팀</label>
                <input type="checkbox" name="chk" id="chk13" className="com_chk" />
                <label htmlFor="chk13">배정팀</label>
                <input type="checkbox" name="chk" id="chk14" className="com_chk" />
                <label htmlFor="chk14">강사관리팀</label>
              </div>
              <div className="check">
                <input type="checkbox" name="chk" id="chk15" className="com_chk" />
                <label htmlFor="chk15">출판 사업부</label>
                <input type="checkbox" name="chk" id="chk16" className="com_chk" />
                <label htmlFor="chk16">입시전략부</label>
                <input type="checkbox" name="chk" id="chk17" className="com_chk" />
                <label htmlFor="chk17">홍보부</label>
                <input type="checkbox" name="chk" id="chk18" className="com_chk" />
                <label htmlFor="chk18">인바운드팀</label>
                <input type="checkbox" name="chk" id="chk19" className="com_chk" />
                <label htmlFor="chk19">부산지사</label>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="7%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="12%" />
                <col width="8%" />
                <col width="8%" />
                <col width="12%" />
                <col width="12%" />
                <col width="12%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>선택</th>
                  <th>학생 명</th>
                  <th>부모 명</th>
                  <th>전화번호</th>
                  <th>수신자</th>
                  <th>홍보자</th>
                  <th>시범강의</th>
                  <th>홍보 책자 발송</th>
                  <th>비고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>17</td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>김학생</td>
                  <td>김부모</td>
                  <td>010-1234-1324</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    김담임103
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    튼튼 홍보자료
                    <br />
                    2023, 01, 05
                  </td>
                  <td className="td_point">-</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>김학생</td>
                  <td>김부모</td>
                  <td>010-1234-1324</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    김담임103
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    튼튼 홍보자료
                    <br />
                    2023, 01, 05
                  </td>
                  <td className="td_point">-</td>
                </tr>
                <tr className="selected">
                  <td>15</td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>김학생</td>
                  <td>김부모</td>
                  <td>010-1234-1324</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    김담임103
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    튼튼 홍보자료
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    <button className="btn_link blue">
                      승인
                      <br />
                      2023, 05, 12
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>김학생</td>
                  <td>김부모</td>
                  <td>010-1234-1324</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    김담임103
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    튼튼 홍보자료
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    <button className="btn_link red">
                      승인
                      <br />
                      2023, 05, 12
                    </button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{13 - idx}</td>
                      <td>
                        <input type="checkbox" id="chk00" className="com_chk" />
                        <label htmlFor="chk00"></label>
                      </td>
                      <td>김학생</td>
                      <td>김부모</td>
                      <td>010-1234-1324</td>
                      <td>
                        <button className="btn_link">가길동201</button>
                      </td>
                      <td>
                        <button className="btn_link">가길동201</button>
                      </td>
                      <td>
                        김담임103
                        <br />
                        2023, 01, 05
                      </td>
                      <td>
                        튼튼 홍보자료
                        <br />
                        2023, 01, 05
                      </td>
                      <td>-</td>
                    </tr>
                  );
                })}
                <tr>
                  <td>7</td>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>김학생</td>
                  <td>김부모</td>
                  <td>010-1234-1324</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    김담임103
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    튼튼 홍보자료
                    <br />
                    2023, 01, 05
                  </td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>
            <div className="com_board_list__bottom">
              <button className="com_btn black xs">선택한 사람 수신자 목록에 추가</button>

              <div className="paging_wrap">
                <Paging />
              </div>
            </div>
          </section>
          <section className="box">
            <div className="detail_tit dot">문자/메일 보내기</div>
            <div className="com_info white">
              <p className="date">2025, 05, 20 11 : 30</p>
            </div>
            <div className="flex_row">
              <div className="rec_tit">발신자 선택</div>
              <div className="check">
                <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                <label htmlFor="rdo01">본인</label>
                <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                <label htmlFor="rdo02">본사</label>
                <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                <label htmlFor="rdo03">부산지사</label>
                <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                <label htmlFor="rdo04">올뎃</label>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="flex_row">
              <div className="rec_tit">수신자 (247명)</div>
            </div>
            <div className="mail_list">
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324ㆍaslfkdas@gmail.com)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324ㆍaslfkdas@gmail.com)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324ㆍaslfkdas@gmail.com)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
            </div>
            <div className="default_tit">발신 방법 선택</div>
            <div className="com_btn_wrap send">
              <button className="com_btn black col_half btn_msg_orange">문자 보내기</button>
              <button className="com_btn btn_request col_half btn_mail_orange">메일</button>
            </div>
            <div className="default_tit">발신 내용</div>
            <div className="com_comment_wrap">
              {/*<div className="com_input_wrap">
                <select className="select">
                  <option value="발신 내용 선택">발신 내용 선택</option>
                </select>
                <button
                  onClick={() => {
                    setModalRegisterContents(true);
                  }}
                  className="com_btn orange xs btn_settings"
                >
                  문자/메일 내용 설정
                </button>
              </div>*/}
              <input type="text" className="input lightGray" defaultValue={`제목 입력`} />
              <textarea className="textarea" placeholder="내용 입력(에디터)"></textarea>
            </div>
            <div className="com_input_upload">
              <Upload title="파일 등록" className="com_btn gray s wl" />
              <p className="file">
                <span className="txt">File name.pdf</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
                <button type="button" className="btn_down" onClick={() => {}}></button>
              </p>
            </div>
            <hr className="com_divider" />
            <div className="default_tit">발송불가 (27명)</div>
            <div className="mail_list">
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324ㆍaslfkdas@gmail.com)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324ㆍaslfkdas@gmail.com)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324ㆍaslfkdas@gmail.com)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
              <div className="mail flex_row">
                <span className="txt">김학생 (010-1234-1324)</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
              </div>
            </div>
            <div className="com_btn_wrap center bottom">
              <button
                onClick={() => {
                  setModalAlert(true);
                }}
                className="com_btn orange xs"
              >
                보내기
              </button>
            </div>
          </section>
        </section>
      </div>
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <div className="content_container">
          <div className="txt">
            수신자중 일부가 <br />
            전화번호 또는 메일 정보가 없습니다.
            <br />
            정보가 전달 되지 않았습니다.
          </div>
          <div className="btn_container">
            <button className="com_btn gray xs">취소</button>
            <button className="com_btn orange xs">확인</button>
          </div>
        </div>
      </Modal>
    </main>
  );
};

export default SendMail;
